import { BaseModalWindow } from "../../../../../components/modalWindows/BaseModalWindow";
import baseModalstyles from "../../../../../components/modalWindows/styles/BaseModalWindow.module.scss";
import baseStyles from "../../../../styles/index.module.scss";
import { FC, useCallback, useEffect, useRef, useState } from "react";
import GridWrapper from "../../../../../components/controls/GridWrapper";
import { NumberInput, TextInput } from "../../../../../components/controls/inputs";
import classNames from "classnames";
import GridSelectorInput from "../../../../../components/controls/GridSelectorInput";
import { TaxTypeSelectorModal } from "../../../../Dictionaries/TaxType";
import { ICostInfoDTO, IEntitySimpleDTO } from "../../../../../libs/coreapi-dto/@types/common";
import { v4 as uuidv4 } from "uuid";
import { ILotDTO } from "../../../../../libs/coreapi-dto/accounting/lot";
import { useAppContext } from "../../../../../system/providers/appContextProvider";
import { TaxTypeDataProvider } from "../../../../../Services/DataProviders/TaxTypeDataProvider";
import { SearchOption, TaxType } from "../../../../../@types/enumsGlobal";
import { GoodsDataProvider } from "../../../../../Services/DataProviders/GoodsDataProvider";
import { ICreateItem, TaxRatesByType } from "../ActRevaluationForm";
import { KizBoxEntity } from "../../../../Dictionaries/Kiz/KizBoxEntity";
import { BarcodeType, IKizBoxDTO, IKizDTO } from "../../../../../libs/coreapi-dto/dirs/kiz";
import { KizDataProvider } from "../../../../../Services/DataProviders/KizDataProvider";
import buffer from "buffer";
import { useTranslation } from "react-i18next";
import { useLotRemain } from "../../../../../components/lotSelector/useLotRemain";
import { PricingModelDataProvider } from "../../../../../Services/DataProviders/PricingModelDataProvider";
import useRevaluationItemCalculator from "./useRevaluationItemCalculator";
import { IActRevaluationItemCreateDTO, IActRevaluationItemEditDTO } from "../../../../../libs/coreapi-dto/documents/ActRevaluationItem";
import { DecimalInputV2 } from "../../../../../components/controls/inputs/BaseInput";
import { useForm } from "../../../../../system/hooks/useForm";
import { useTimeout } from "../../../../../system/hooks/useTimeout";
import { DateTime } from "luxon";
import { KizParsed } from "../../../../Dictionaries/Kiz/KizParsed";
import style from "./styles/ActRevaluationItemModal.module.scss"
import { ContractorDataProvider } from "../../../../../Services/DataProviders/ContractorDataProvider";
import { IContractorDTO } from "../../../../../libs/coreapi-dto/dirs/contractor";
import { IPricingModelDTO } from "../../../../../libs/coreapi-dto/dirs/pricingModel";
import { PricingRevaluationDataProvider } from "../../../../../Services/DataProviders/PricingRevaluationDataProvider";
import { IGoodsDTO } from "../../../../../libs/coreapi-dto/dirs/goods";
import { IPricingAdpricePercentResponse, IPricingRevaluationItem, IPricingRevaluationItemDTO, IPricingRevaluationSingleItem } from "../../../../../libs/coreapi-dto/dirs/pricingRevaluation";

interface IActRevaluationItemCreateModal {
    idGlobal?: string;
    idDocument: string;
    ok: (createItem: ICreateItem) => void;
    cancel: () => void;
    revaluationLot: ILotDTO | null;
    pricingModelId: string;
    scanData?: string;
    searchOption: SearchOption;
    items: IActRevaluationItemCreateDTO[];
}

interface IKizs {
    kiz: IKizDTO[];
    kizBox: IKizBoxDTO[];
    kizOsuDtos: IKizDTO[];
}

interface InitializeKizOrBoxResult {
  hasKiz: boolean;
  hasKizBox: boolean;
  kizData?: IKizDTO;        // данные одного КИЗ
  kizBoxData?: IKizBoxDTO;  // данные Короба
  kizOsuDtos?: IKizDTO
}

interface IValidator {
    quantity: number;
    retailTaxType: string;
}

export const ActRevaluationItemCreateModal: FC<IActRevaluationItemCreateModal> = (props) => {
    const appCtx = useAppContext();

    const idGlobal: string = props.idGlobal ?? uuidv4();

    const goodsDP = new GoodsDataProvider(appCtx.coreApiService);
    const pricingModelDP = new PricingModelDataProvider(appCtx.coreApiService);
    const pricingRevaluationDP = new PricingRevaluationDataProvider(appCtx.coreApiService);
    const taxTypeDP = new TaxTypeDataProvider(appCtx.coreApiService);
    const kizDP = new KizDataProvider(appCtx.coreApiService);
    const contractorDP = new ContractorDataProvider(appCtx.coreApiService);

    const [createItem, setCreateItem] = useState<ILotDTO>(props.revaluationLot as ILotDTO);
    const [prevItem] = useState<ILotDTO>(props.revaluationLot as ILotDTO);

    const createItemRef = useRef(createItem);

    useEffect(() => {
        createItemRef.current = createItem;
    }, [createItem]);
    
    const [sendRequest, setSendRequest] = useState<boolean>(false);
    const [kizs, setKizs] = useState<IKizs>({ kiz: [], kizBox: [], kizOsuDtos: []});
    const [retailTaxType, setRetailTaxType] = useState<IEntitySimpleDTO>();
    const [supplierTaxType, setSupplierTaxType] = useState<IEntitySimpleDTO>();
    const lotRemain = useLotRemain(prevItem?.idGlobal as string, props.idDocument);
    const [quantity, setQuantity] = useState<number>(1);
    const [adprice, setAdprice] = useState<number>();
    const [priceIncVat, setPriceIncVat] = useState<number>();
    const [setTimer, clearTimer]  = useTimeout()

    const [initModal, setInitModal] = useState<boolean>(false);
    const [initVatValues, setInitVatValues] = useState<boolean>(false);

    const [isGnvls, setIsGnvls] = useState<boolean>(false);

    // --- Инициализация isGnvls ---
    const initializeGnvlsAttribute = useCallback(async (): Promise<boolean> => {

        console.info(`[initializeGnvlsAttribute]`);

        return new Promise((resolve) => {
            if (!props.revaluationLot) {
                console.warn(`[initializeGnvlsAttribute] Нет revaluationItem`);
                setIsGnvls(false);
                resolve(false);
                return;
            }

            const goodsId = props.revaluationLot.goods.idGlobal;
            if (!goodsId) {
                console.warn(`[initializeGnvlsAttribute] Нет idGlobal у товара`);
                setIsGnvls(false);
                resolve(false);
                return;
            }

            goodsDP.getById(
                goodsId,
                (goods: IGoodsDTO) => {
                    const isGnvlsValue = goods.gnvls.important ?? false;
                    setIsGnvls(isGnvlsValue);
                    resolve(isGnvlsValue);
                },
                (error: any) => {
                    console.error(`[initializeGnvlsAttribute] Ошибка загрузки товара:`, error);
                    setIsGnvls(false);
                    resolve(false);
                }
            );
        });
    }, [props.revaluationLot]);

    // --- Инициализация adprice ---
    const initializeAdprice = useCallback(async (isGnvlsValue: boolean): Promise<number> => {

        console.info(`[initializeAdprice]`);

        return new Promise((resolve) => {
            if (!props.revaluationLot) {
                setAdprice(0);
                resolve(0);
                return;
            }

            pricingModelDP.getById(
                props.pricingModelId,
                (pricing: IPricingModelDTO) => {
                    if (isGnvlsValue && pricing.pricingExtremeAdpriceSchemaType) {
                        pricingRevaluationDP.calculateAdpricePercent(
                            props.pricingModelId,
                            {
                                eventType: "RetailPriceWithVatChanged",
                                hasAdprice: false,
                                hasRetailPrice: true,
                                revaluationItem: {
                                    idStoreGlobal: props.revaluationLot?.store?.idGlobal,
                                    idSupplierGlobal: props.revaluationLot?.idSupplierGlobal,
                                    item: {
                                        quantity: props.revaluationLot?.quantityRem,
                                        adPrice: props.revaluationLot?.retailCostInfo?.adprice,
                                        idGoodsGlobal: props.revaluationLot?.goods.idGlobal,
                                        idScalingRatioGlobal: props.revaluationLot?.scalingRatio.idGlobal,
                                        producerPrice: props.revaluationLot?.producerPrice,
                                        registerPrice: props.revaluationLot?.registerPrice,
                                        retailCostInfo: props.revaluationLot?.retailCostInfo,
                                        supplierCostInfo: props.revaluationLot?.supplierCostInfo,
                                        numerator: props.revaluationLot?.numerator ?? 1,
                                        denominator: props.revaluationLot?.denominator ?? 1,
                                    } as IPricingRevaluationItem
                                } as IPricingRevaluationSingleItem
                            } as IPricingRevaluationItemDTO, //TODO: Доработать формат данных для получения предельной наценки
                            (response: IPricingAdpricePercentResponse) => {
                                const adprice = response.defaultPercent;
                                setAdprice(adprice);
                                pricingCalculator.recalculateByAdprice(adprice);

                                console.info(`[initializeAdprice] Наценка: ${adprice}%`);
                                resolve(adprice);
                            },
                            null,
                            (error: any) => {
                                console.info(`[initializeAdprice] Ошибка расчёта, fallback`, error);
                                const fallbackAdprice: number = isGnvlsValue
                                    ? pricing.adpricePercentDfZhnvls
                                    : pricing.adpricePercentDf;
                                setAdprice(fallbackAdprice);
                                pricingCalculator.recalculateByAdprice(fallbackAdprice);

                                resolve(fallbackAdprice);
                            }
                        );
                    } else {
                        const adprice = isGnvlsValue
                            ? pricing.adpricePercentDfZhnvls
                            : pricing.adpricePercentDf;
                        setAdprice(adprice);
                        pricingCalculator.recalculateByAdprice(adprice);

                        resolve(adprice);
                    }
                },
                (error: any) => {
                    console.warn(`[initializeAdprice] Ошибка загрузки МЦО`, error);
                    setAdprice(0);
                    resolve(0);
                }
            );
        });
    }, [props.revaluationLot, props.pricingModelId]);

    // --- Обработка сканирования ---
    const initializeKizOrBox = useCallback(
        async (scanData: string, numeratorValue: number): Promise<InitializeKizOrBoxResult> => {
            return new Promise((resolve) => {
                console.info('[initializeKizOrBox]');

                const kizSearchOptionSelected: boolean = props.searchOption === SearchOption.kizOrKizBox
                    || props.searchOption === SearchOption.gtinSgtin;

                if (!scanData || !kizSearchOptionSelected) {
                    resolve({ hasKiz: false, hasKizBox: false });
                    return;
                }

                // Очистка от GS (ASCII 29)
                const formatted = scanData.length === 18 ? '00' + scanData : scanData;
                const cleanFormatted = formatted.replace(/\u001D/g, '');
                const base64 = buffer.Buffer.from(cleanFormatted, 'ascii').toString('base64');
                const encodedBarcodeBase64 = encodeURIComponent(base64);
                kizDP.parse(
                    encodedBarcodeBase64,
                    (parsed) => {
                        if (KizBoxEntity.isKizBox(scanData)) {

                            resolve({
                                hasKiz: false,
                                hasKizBox: true,
                                kizBoxData: {
                                    ...parsed.kizBoxData,
                                    idGlobal: uuidv4(),
                                    quantity: numeratorValue ?? 1,
                                },
                            });
                        } else {
                            const kizParsed = new KizParsed(scanData);
                            if (!kizParsed.isKiz) {
                                return resolve({ hasKiz: false, hasKizBox: false });
                            }
                            
                            const isPieceAccounting = createItem.isPieceAccountingKizOsu;

                            const isKizOsu = parsed.barcodeType == BarcodeType.kizOsu;
                            const key = isPieceAccounting ? 'kizOsuDtos' : 'kizData';

                            if (isKizOsu && isPieceAccounting) {
                                const kizResult = {
                                hasKiz: true,
                                hasKizBox: false,
                                [key]: {
                                    ...parsed.kizOsuData,
                                    idGlobal: uuidv4(),
                                    }
                                };
                                resolve(kizResult);
                            }
                            else {
                                const kizResult = {
                                hasKiz: true,
                                hasKizBox: false,
                                [key]: {
                                    ...parsed.kizData,
                                    idGlobal: uuidv4(),
                                    }
                                };
                                resolve(kizResult);
                            }
                        }
                    },
                    () => {
                        console.warn(`Ошибка разбора КИЗ / DataMatrix: ${scanData}`)
                    }
                );
            });
        },
        []
    );

    useEffect(() => {

        let isCancelled = false;

        const process = async () => {

            if (initModal) {
                return;
            }

            if (!retailTaxType?.idGlobal) {
                console.info('Предупреждение: не загружены данные СтНДСРозн');
                return;
            }

            try {
                // 1. Парсим КИЗ/КИЗ-короб
                let hasAnyKiz = props.scanData && props.scanData.length > 0;
                let resultKizData: IKizs = { kiz: [], kizBox: [], kizOsuDtos: [] };
                if (hasAnyKiz) {
                    const numeratorValue = props.revaluationLot?.numerator ?? 1;
                    const { hasKiz, hasKizBox, kizData, kizBoxData, kizOsuDtos } = await initializeKizOrBox(props.scanData as string, numeratorValue);
                    hasAnyKiz = hasKiz || hasKizBox;

                    if (hasKiz && kizData) {
                        resultKizData = { kiz: [kizData], kizBox: [], kizOsuDtos: [] };
                    }
                    else if (hasKiz && kizOsuDtos) {
                        resultKizData = { kiz: [], kizBox: [], kizOsuDtos: [kizOsuDtos]  };
                    } else if (hasKizBox && kizBoxData) {
                        resultKizData = { kiz: [], kizBox: [kizBoxData], kizOsuDtos: [] };
                    }

                    setKizs(resultKizData);
                }

                // 2. Загружаем isGnvls
                const isGnvlsValue = await initializeGnvlsAttribute();

                // 3. Установка максимальной наценки
                // 4. Если подбор через сканирование КИЗ - закрыть форму
                await initializeAdprice(isGnvlsValue);
                if (hasAnyKiz && isValid())
                    props.ok(await returnCreateItem(isGnvlsValue, resultKizData));

                setInitModal(true);

            } catch (error) {
                console.error('Ошибка обработки сканирования:', error);
            }
        };

        if (!isCancelled) {
            process();
        }

        return () => {
            isCancelled = true;
        };
    }, [props.scanData, retailTaxType]);

    const getEditItem = (isGnvlsValue: boolean, kizData?: IKizs, createItem?: ILotDTO): IActRevaluationItemEditDTO => {

        // Подмена на ссылку актуального состояния
        if (!createItem) createItem = createItemRef.current;

        const fallbackKizData = kizs;
        kizData = kizData ?? fallbackKizData;

        // Если какой-то из массивов пуст → заменяем его на fallback
        const resolvedKizs = (kizData.kiz && kizData.kiz.length > 0) ? kizData.kiz : fallbackKizData.kiz;
        const resolvedKizBoxes = (kizData.kizBox && kizData.kizBox.length > 0) ? kizData.kizBox : fallbackKizData.kizBox;
        const resolvedKizOsuDtos = (kizData.kizOsuDtos && kizData.kizOsuDtos.length > 0) ? kizData.kizOsuDtos : fallbackKizData.kizOsuDtos;
        
        let item = props.items.find((c) => c.idLotGlobal === createItem?.idGlobal);
        if (!item) {
             return {
                idGlobal: idGlobal,
                idLotGlobal: createItem.idGlobal,
                retailCostInfo: createItem.retailCostInfo,
                supplierCostInfo: createItem.supplierCostInfo,
                quantity: quantity,
                lotName: createItem.lotName,
                producerPrice: createItem.producerPrice,
                isKiz: createItem.isKiz,
                isKizBox: createItem.isKizBox,
                kizs: resolvedKizs,
                isGnvls: isGnvlsValue,
                kizBoxes: resolvedKizBoxes,
                isPieceAccountingKizOsu: createItem.isPieceAccountingKizOsu,
                kizOsuDtos: resolvedKizOsuDtos,
                goodsCode: createItem.goodsCode,
                producer: createItem.producer.displayName,
                retailAdpriceOld: prevItem?.retailCostInfo.adprice,
                retailPriceIncVatOld: prevItem?.retailCostInfo?.priceIncVat,
                idGoodsGlobal: createItem.goods.idGlobal,
                idScalingRatioGlobal: createItem.scalingRatio.idGlobal,
                dateCreated: DateTime.now(),
                isOsu: createItem?.kizOsuDto?.barcode !== undefined,
                kizOsuDto: createItem?.kizOsuDto?.barcode !== undefined ? { ...createItem?.kizOsuDto, idDocumentItem: idGlobal } : undefined,
                gtin: createItem.gtin
            } as IActRevaluationItemCreateDTO;
        }

        const totalKizCount = [...item.kizs ?? [], ...resolvedKizs].length + [...item.kizBoxes ?? [], ...resolvedKizBoxes].length + [...item.kizOsuDtos ?? [], ...resolvedKizOsuDtos].length;
        let quantityFinally = quantity + item.quantity;

        if (quantityFinally > totalKizCount && totalKizCount > 0) {
            quantityFinally = item.quantity
        }

        return {
            idGlobal: item.idGlobal,
            idLotGlobal: createItem.idGlobal,
            isGnvls: isGnvlsValue,
            retailAdpriceOld: prevItem?.retailCostInfo.adprice,
            retailPriceIncVatOld: prevItem?.retailCostInfo?.priceIncVat,
            retailCostInfo: {
                vat: createItem?.retailCostInfo.vat,
                price: createItem?.retailCostInfo.price,
                vatPrice: createItem?.retailCostInfo.vatPrice,
                priceIncVat: createItem?.retailCostInfo.priceIncVat,
                sum: +((createItem?.retailCostInfo.price ?? 0) * +(quantityFinally)).toFixed(2),
                vatSum: +((createItem?.retailCostInfo.vat ?? 0) * +(quantityFinally)).toFixed(2),
                sumIncVat: +((createItem?.retailCostInfo.priceIncVat ?? 0) * +(quantityFinally)).toFixed(2),
                adprice: createItem?.retailCostInfo.adprice,
            } as ICostInfoDTO,
            supplierCostInfo: {
                vat: createItem?.supplierCostInfo.vat,
                price: createItem?.supplierCostInfo.price,
                vatPrice: createItem?.supplierCostInfo.vatPrice,
                priceIncVat: createItem?.supplierCostInfo.priceIncVat,
                sum: +((createItem?.supplierCostInfo.price ?? 0) * +(quantityFinally)).toFixed(2),
                vatSum: +((createItem?.supplierCostInfo.vat ?? 0) * +(quantityFinally)).toFixed(2),
                sumIncVat: +((createItem?.supplierCostInfo.priceIncVat ?? 0) * +(quantityFinally)).toFixed(2),
                adprice: createItem?.supplierCostInfo.adprice,
            } as ICostInfoDTO,
            quantity: quantityFinally,
            producerPrice: createItem.producerPrice,
            isKiz: createItem.isKiz,
            isKizBox: createItem.isKizBox,
            kizs: [...item.kizs ?? [], ...resolvedKizs],
            kizBoxes: [...item.kizBoxes ?? [], ...resolvedKizBoxes],
            kizOsuDtos: [...item.kizOsuDtos ?? [], ...resolvedKizOsuDtos],
            isPieceAccountingKizOsu: createItem.isPieceAccountingKizOsu,
            idGoodsGlobal: createItem.goods.idGlobal,
            goodsCode: createItem.goodsCode,
            producer: createItem.producer.displayName,
            idScalingRatioGlobal: createItem.scalingRatio.idGlobal,
            dateCreated: DateTime.now(),
            isOsu: createItem?.kizOsuDto?.barcode !== undefined,
            kizOsuDto: createItem?.kizOsuDto?.barcode !== undefined ? { ...createItem?.kizOsuDto, idDocumentItem: item.idGlobal } : undefined,
            gtin: createItem.gtin,
        } as IActRevaluationItemCreateDTO;
    };

    const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
    const returnCreateItem = async (isGnvlsValue: boolean, kizData?: IKizs): Promise<ICreateItem> => {

        let attempts = 0;
        const maxAttempts = 50;

        while (!isAdpriceCalculatedRef.current && attempts < maxAttempts) {
            await delay(333);
            attempts++;
        }

        if (!isAdpriceCalculatedRef.current) {
            throw new Error('[returnCreateItem] строка не была рассчитана за отведённое время');
        }

        let result = getEditItem(isGnvlsValue, kizData);
        return {
            item: result,
            displayItem: {
                idGlobal: result.idGlobal,
                goodsName: createItem.goods.displayName,
                storeName: createItem.store.displayName,
                goodsCode: createItem.goodsCode,
                retailAdprice: result.retailCostInfo.adprice,
                retailAdpriceOld: prevItem?.retailCostInfo.adprice,
                retailPriceIncVatOld: prevItem?.retailCostInfo?.priceIncVat,
                producer: createItem.producer.displayName,
                idLotGlobal: createItem.idGlobal,
                retailPriceIncVat: result.retailCostInfo?.priceIncVat ?? 0,
                retailSumIncVat: result.retailCostInfo?.sumIncVat ?? 0,
                quantity: result.quantity,
                isKiz: createItem.isKiz === undefined ? createItem.isKizFlag : createItem.isKiz,
                isGnvls: isGnvlsValue,
                countKizScan: result?.isOsu ? 1 : (result?.kizs?.length ?? 0) + (result?.kizBoxes?.length ?? 0) + (result?.kizOsuDtos?.length ?? 0),
                dateCreated: DateTime.now(),
                isOsu: createItem.kizOsuDto?.barcode !== undefined
            },
            goodsInfo: {
                idGoods: createItem.goods.idGlobal,
                idScalingRatio: createItem.scalingRatio.idGlobal,
                idGlobal: result.idGlobal,
            },
        };
    };
    const { t } = useTranslation();

    useEffect(() => {
        taxTypeDP.getView(
            { 
                numberPerPage: 1, 
                pageNumber: 1, 
                columnFilters: [
                    { 
                        name: "taxRate", 
                        operator: "Eq", 
                        value: createItem?.retailCostInfo.vat.toString()
                    }] 
            }, 
            (value) => setRetailTaxType({ idGlobal: value[0]?.idGlobal, displayName: value[0]?.displayName })
        );
    }, [createItem.retailCostInfo.vat]);

    useEffect(() => {
        taxTypeDP.getView(
            { 
                numberPerPage: 1, 
                pageNumber: 1, 
                columnFilters: 
                [
                    { 
                        name: "taxRate", 
                        operator: "Eq", 
                        value: createItem?.supplierCostInfo.vat.toString()
                    }] 
                }, 
                (value) => setSupplierTaxType({ idGlobal: value[0]?.idGlobal, displayName: value[0]?.displayName })
        );
    }, [createItem.supplierCostInfo.vat]);

    const zeroCostInfo: ICostInfoDTO = { vat: 0, price: 0, vatPrice: 0, priceIncVat: 0, sum: 0, vatSum: 0, sumIncVat: 0, adprice: 0 };
    const pricingCalculator = useRevaluationItemCalculator({
        quantity: quantity,
        isGnvls: isGnvls,
        productMargin: createItem.productMargin ?? props.revaluationLot?.productMargin ?? 0,
        retailCostInfo: props.revaluationLot?.retailCostInfo ?? zeroCostInfo,
        supplierCostInfo: props.revaluationLot?.supplierCostInfo ?? zeroCostInfo,
        lot: props.revaluationLot as ILotDTO,
        idPricingModel: props.pricingModelId,
        renderAlerts: true,
        onStartRequest: () => {
            setSendRequest(true)
        },
        onEndRequest: () => {
            if (initVatValues) {
                setSendRequest(false);
                return;
            }

            // Отправляем запрос на проверку контрагента аптеки 1 раз
            setInitVatValues(true)
            setSendRequest(true)

            // Если ставка поставщика НЕ 0, то проверяем контрагент аптеки на признак
            // "Плетельщик НДС"
            // в случае, если аптека является плательщиком - устанавливаем новое значение ставки НДС розн.
            const lotSupplierVat = createItem?.supplierCostInfo.vat;
            if (lotSupplierVat !== 0) {
                contractorDP.getById(createItem?.contractor.idGlobal, (contractor: IContractorDTO) => {
                    if (contractor.useVat && (contractor.taxType == TaxType.SimplifiedRate5 || contractor.taxType == TaxType.SimplifiedRate7)) {
                        let rate = contractor.taxType == TaxType.SimplifiedRate5 ? 5 : 7;

                        setTimeout(() => {
                            pricingCalculator.setRetailVat(rate);
                            pricingCalculator.retailTaxTypeChange(props.revaluationLot?.retailCostInfo.vat as number);
                            setSendRequest(false)
                        }, 1333);
                    } else {
                        setSendRequest(false)
                    }
                });
            } else {
                setSendRequest(false)
            }
        },
        onDataReceived: (state, actionType, payload) => {
            const retailAdprice = actionType === "AdPriceChanged"
                ? payload
                : state.retailCostInfo.adprice;
            const nextState = {
                ...state,
                retailCostInfo: {
                    ...state.retailCostInfo,
                    adprice: retailAdprice
                }
            };

            setCreateItem({ ...createItem, ...nextState })
            setPriceIncVat(state.retailCostInfo.priceIncVat)
            setAdprice(retailAdprice)
            setQuantity(state.quantity)

            setIsAdpriceCalculated(true)
        },
    });

    const [isAdpriceCalculated, setIsAdpriceCalculated] = useState(false);
    const isAdpriceCalculatedRef = useRef(isAdpriceCalculated);

    // Синхронизируем ref при каждом изменении состояния
    useEffect(() => {
        isAdpriceCalculatedRef.current = isAdpriceCalculated;
    }, [isAdpriceCalculated]);

    const { isValid, errors, setErrors } = useForm<IValidator>({
        validations: {
            quantity: {
                required: {
                    value: !(quantity > 0),
                    message: "Значение должно быть больше 0",
                },
            },
            retailTaxType: {
                required: {
                    value: retailTaxType && retailTaxType.displayName  ? false : true,
                    message: "Введите значение",
                },
            }
        },
    });

    const changeDataTimeout = (setState: any) => (value: any) => {
        setTimer(() => setState(value))
    }

    const changeDataFast = (setState: any) => (value: any) => {
        clearTimer(() => setState(value))
    }

    return (
        <BaseModalWindow
            header={`${t("documents.actRevaluation.title")} - ${createItem.goods.displayName}`}
            ok={{
                onClick: async () => {
                    if (isValid()) {
                        setIsAdpriceCalculated(true);
                        props.ok(await returnCreateItem(isGnvls));
                    }
                },
                disabled: sendRequest,
                sendRequestSpinner: sendRequest,
            }}
            cancel={{ onClick: props.cancel }}
            modalWindowClassName={baseModalstyles.flexHeightModalWindow}
            footerStyle="customStyles"
        >
            <GridWrapper cols={3}>
                <GridSelectorInput id="idVatSupplier" selectorModalJsx={TaxTypeSelectorModal} label="Ставка НДС пост.%" selectedEntity={supplierTaxType} disabled />
                <GridSelectorInput
                    className={style.GridSelectorInput_defaultMargin}
                    id="idVatRetail"
                    selectorModalJsx={TaxTypeSelectorModal}
                    label="Ставка НДС розн.%"
                    selectedEntity={retailTaxType}
                    onSelect={(value) => {
                        if (TaxRatesByType.hasOwnProperty(value.displayName)) {
                            setRetailTaxType(value)
                            pricingCalculator.setRetailVat(TaxRatesByType[value.displayName]);
                            pricingCalculator.retailTaxTypeChange(props.revaluationLot?.retailCostInfo.priceIncVat as number) // Расчёт по старой цене
                        }
                    }}
                    onClear={() => setRetailTaxType({ displayName: '', idGlobal: '' })}
                    error={errors.retailTaxType}
                    onFocus={() => setErrors({ ...errors, retailTaxType: undefined })}
                />  
                <TextInput label="Единица измерения" value={createItem?.scalingRatio.displayName} disabled />
            </GridWrapper>
            <div className={classNames(baseStyles.slimSeparator, baseStyles.slimSeparator_horizontal)} />
            <GridWrapper cols={6}>
                <DecimalInputV2 label="Старая наценка" value={prevItem?.retailCostInfo.adprice ?? 0} disabled />
                <DecimalInputV2 label="Старая цена" value={prevItem?.retailCostInfo?.priceIncVat ?? 0} disabled />
                <DecimalInputV2 label="Наценка %" value={adprice}
                onChange={changeDataTimeout((value: number) => { pricingCalculator.adpriceChange(value); setAdprice(value) })}
                onEndChange={changeDataFast((value: number) => { pricingCalculator.adpriceChange(value); setAdprice(value) })}
                />
                <NumberInput
                    required
                    keyBan={true}
                    onFocus={() => setErrors({ ...errors, quantity: undefined })}
                    error={errors.quantity}
                    label="Кол-во"
                    value={quantity}
                    min={0}
                    max={lotRemain}
                    onChange={changeDataTimeout((value: number) => { pricingCalculator.quantityChange(value); setQuantity(value) })}
                    onEndChange={changeDataFast((value: number) => { pricingCalculator.quantityChange(value); setQuantity(value) })}
                />
                <NumberInput label="На складе" value={lotRemain} disabled />
            </GridWrapper>
            <GridWrapper cols={6}>
                <DecimalInputV2 label="Цена пост." value={createItem.supplierCostInfo?.price ?? 0} disabled />
                <DecimalInputV2 label="В т.ч НДС пост." value={createItem.supplierCostInfo?.vatPrice ?? 0} disabled />
                <DecimalInputV2 label="Цена пост. с НДС" value={createItem.supplierCostInfo?.priceIncVat ?? 0} disabled />
                <DecimalInputV2 label="Сумма пост." value={createItem.supplierCostInfo?.sum ?? 0} disabled />
                <DecimalInputV2 label="Сумма НДС пост." value={createItem.supplierCostInfo?.vatSum ?? 0} disabled />
                <DecimalInputV2 label="Сумма пост. с НДС" value={createItem.supplierCostInfo?.sumIncVat ?? 0} disabled />
            </GridWrapper>
            <GridWrapper cols={6}>
                <DecimalInputV2 label="Цена розн." value={createItem.retailCostInfo?.price ?? 0} disabled />
                <DecimalInputV2 label="В т.ч НДС розн." value={createItem.retailCostInfo?.vatPrice ?? 0} disabled />
                <DecimalInputV2 label="Цена розн. с НДС" value={priceIncVat}
                onChange={changeDataTimeout((value: number) => { pricingCalculator.priceIncVatChange(value); setPriceIncVat(value) })}
                onEndChange={changeDataFast((value: number) => { pricingCalculator.priceIncVatChange(value); setPriceIncVat(value) })}
                />
                <DecimalInputV2 label="Сумма розн." value={createItem.retailCostInfo?.sum ?? 0} disabled />
                <DecimalInputV2 label="Сумма НДС розн." value={createItem.retailCostInfo?.vatSum ?? 0} disabled />
                <DecimalInputV2 label="Сумма розн. с НДС" value={createItem.retailCostInfo?.sumIncVat ?? 0} disabled />
            </GridWrapper>
        </BaseModalWindow>
    );
};

export default ActRevaluationItemCreateModal;
